<template>
  <div>
    <v-select
      @click.native.prevent="columnDialog = true"
      multiple
      :menu-props="{ value: false }"
      v-model="contextSelectedColumns"
      append-icon="fa-columns"
      :label="$t('global.columns')"
      hide-details
      small-chips
      :items="availableColumns"
      item-text="text"
      item-value="selectValue"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index < 2" color="primary" text-color="white">
          <span>{{ item.text }}</span>
        </v-chip>
        <span v-if="index === 2" class="grey--text caption">(+{{ selectedColumns.length - 2 }} {{ $t("global.others") }})</span>
      </template>
    </v-select>
    <v-dialog v-model="columnDialog" max-width="650px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <h3>{{ $t("global.available") }}</h3>
              <draggable class="dragArea list-group" :list="contextAvailableColumns" :group="{ name: 'people', pull: 'clone', put: true }" @change="log">
                <v-chip v-for="element in contextAvailableColumns" :key="element.selectValue" style="display: block" class="my-1">
                  {{ element.text }} <v-btn icon class="addIcon" text @click="addItem(element)"><v-icon>add</v-icon></v-btn>
                </v-chip>
              </draggable>
            </v-col>
            <v-col cols="6">
              <h3>{{ $t("global.selected") }}</h3>
              <draggable class="dragArea list-group" :list="contextSelectedColumns" group="people" @change="log">
                <v-chip
                  class="list-group-item primary white--text my-1"
                  v-for="element in contextSelectedColumns"
                  :key="element.selectValue"
                  style="display: block"
                >
                  {{ element.text }}
                  <v-btn icon class="addIcon accent--hover" text dark @click="removeItem(element)"><v-icon>cancel</v-icon></v-btn>
                </v-chip>
              </draggable>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="columnDialog = false" color="blue darken-1" text>{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "BookingColumnSelect",
  components: { draggable },
  props: {
    selectedColumns: {
      required: true
    },
    availableColumns: {
      required: true
    }
  },
  methods: {
    log() {
      let simple = [];
      for (let row of this.contextSelectedColumns) {
        simple.push(row.selectValue);
      }
      this.$emit("update:selectedColumns", simple);
    },
    removeItem(item) {
      this.contextSelectedColumns.splice(this.contextSelectedColumns.indexOf(item), 1);
      this.log();
    },
    addItem(item) {
      this.contextSelectedColumns.push(item);
      this.log();
    }
  },
  data: () => ({
    columnDialog: false
  }),
  computed: {
    contextAvailableColumns() {
      return this.availableColumns.filter(v => !this.selectedColumns.includes(v.selectValue));
    },
    contextSelectedColumns() {
      let test = [];
      for (let column of this.selectedColumns) {
        test.push(this.availableColumns.find(v => v.selectValue === column));
      }
      return test;
    }
  }
};
</script>

<style>
.dragArea .v-chip__close {
  position: absolute;
  right: 15px;
}
</style>

<style scoped>
.addIcon {
  position: absolute !important;
  right: 0 !important;
  top: -3px !important;
}
.accent--hover:hover {
  color: #44d3af;
}
</style>
